import { createFileRoute, Outlet } from "@tanstack/react-router";

import SearchExpiredModal from "@/components/SearchExpiredModal/SearchExpiredModal";
import { PurchaseStateContextProvider } from "@/contexts/PurchaseStateContext";
import { SearchDataMissingErrorBoundary } from "@/errors/SearchDataMissingErrorBoundary";
import { FlightFiltersProvider } from "@/features/flights/contexts/FlightFiltersContext";
import { FlightSelectionPayloadProvider } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContextProvider";
import { useFlightSearchTokens } from "@/features/flights/hooks/useFlightSearchTokens";
import { useSearchExpiry } from "@/hooks/useSearchExpiry";

export const Route = createFileRoute("/_authenticated/flights/_offers")({
  component: FlightsRoute,
});

function FlightsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  const { query } = useFlightSearchTokens();
  const navigate = Route.useNavigate();
  const { isExpired, handleResetExpiredSearch } = useSearchExpiry("flight");

  const handleRefresh = () => {
    handleResetExpiredSearch();
    navigate({ to: "/flights/departure/list" });
  };

  const handleNewSearch = () => {
    handleResetExpiredSearch();
    navigate({ to: "/flights/search" });
  };

  return (
    <FlightFiltersProvider defaultFilters={query.data?.defaultFilters || null}>
      <FlightSelectionPayloadProvider>
        <PurchaseStateContextProvider>
          <Outlet />
          <SearchExpiredModal
            open={isExpired}
            type="flight"
            onRefresh={handleRefresh}
            onNewSearch={handleNewSearch}
          />
        </PurchaseStateContextProvider>
      </FlightSelectionPayloadProvider>
    </FlightFiltersProvider>
  );
}
